import { AbstractApiModel } from '@ng-cloud/badger-core/models/abstract-api-model';

export class Sku extends AbstractApiModel<Sku> {
  clientSku: string;
  itemName: string;
  sku: string;
  organizationId: number;

  deserialize(json: any): this {
    this.clientSku = json.client_sku;
    this.itemName = json.item_name;
    this.sku = json.sku;
    this.organizationId = json.organization_id;
    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      id: this.id,
      client_sku: this.clientSku,
      item_name: this.itemName,
      sku: this.sku,
      organization_id: this.organizationId
    });
  }
}
